import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { NotificationContext } from "../../context/NotificationContext";
import { useAuthContext } from "../../context/AuthProvider";
import FloatingNotifications from "./FloatingNotifications";
import Header from "./Header";
import Navbar from "./Navbar";

function Wrapper() {
  const location = useLocation();
  const { authState, QCFull } = useAuthContext();

  if (!authState?.isLoggedIn) {
    return <Navigate to="/login" />;
  }
  return (
    <>
      {location.pathname !== "/" &&
        location.pathname !== "/plant" &&
        location.pathname !== "/control" &&
        location.pathname !== "/summary" && (
          <>
            <Header />
            <Navbar />
          </>
        )}
      <div
        style={{
          width: "100%",
          backgroundColor: "#FAFAFA",
        }}
      >
        <Outlet />
      </div>
    </>
  );
}

export default Wrapper;
